import React, { useState, useEffect } from 'react';
import './stats.css';

const Stats = ({ records, onEdit, selectedPerson }) => {
  const [selectedName, setSelectedName] = useState(selectedPerson || '');

  // Get unique names from records object keys
  const names = Object.keys(records).sort();

  // Update selectedName when selectedPerson prop changes
  useEffect(() => {
    if (selectedPerson) {
      setSelectedName(selectedPerson);
    }
  }, [selectedPerson]);

  // Get records for selected person
  const selectedRecords = selectedName && records[selectedName] 
    ? records[selectedName].sort((a, b) => new Date(a.date) - new Date(b.date)) 
    : [];

  // Questions/categories in order
  const categories = [
    { key: 'eating', label: 'Eating', max: 10 },
    { key: 'workingOut', label: 'Working Out', max: 10 },
    { key: 'running', label: 'Running', max: 10 },
    { key: 'walking', label: 'Walking', max: 10 },
    { key: 'alcohol', label: 'Alcohol', max: 10 },
    { key: 'supplements', label: 'Supplements', max: 10 },
    { key: 'meditation', label: 'Meditation', max: 10 },
    { key: 'hydration', label: 'Hydration', max: 5 },
    { key: 'bonus', label: 'Bonus', max: 10 }
  ];

  // Calculate total for a single day's record
  const calculateDayTotal = (record) => {
    return categories.reduce((sum, category) => {
      const value = record[category.key] ?? 0;  // Use nullish coalescing to default to 0
      return sum + Number(value);
    }, 0);
  };

  return (
    <div className="stats-container">
      <div className="name-toggles">
        {names.map(name => (
          <button
            key={name}
            className={`name-button ${selectedName === name ? 'active' : ''}`}
            onClick={() => setSelectedName(name)}
          >
            {name}
          </button>
        ))}
      </div>

      {selectedName && (
        <div className="stats-table-container">
          <table className="stats-table">
            <thead>
              <tr>
                <th>Category</th>
                {selectedRecords.map(record => (
                  <th key={record.date}>
                    {record.date}
                    <button 
                      className="edit-button"
                      onClick={() => onEdit(record)}
                      title="Edit record"
                    >
                      ✎
                    </button>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {categories.map(category => (
                <tr key={category.key}>
                  <td className="category-label">
                    {category.label} (max {category.max})
                  </td>
                  {selectedRecords.map(record => (
                    <td key={record.date}>{record[category.key]}</td>
                  ))}
                </tr>
              ))}
              <tr className="total-row">
                <td>Daily Total</td>
                {selectedRecords.map(record => (
                  <td key={record.date}>{calculateDayTotal(record)}</td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {!selectedName && (
        <div className="no-selection">
          Please select a name to view their statistics
        </div>
      )}
    </div>
  );
};

export default Stats;
